import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const ArrowLeft: IconNode = [
  'svg',
  defaultAttributes,
  [
    ['path', { d: 'm12 19-7-7 7-7' }],
    ['path', { d: 'M19 12H5' }],
  ],
];

export default ArrowLeft;
